import React, { useState, useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { ReactReduxContext, useSelector } from 'react-redux'
import { Button, Spinner } from 'react-bootstrap'
import apiClient from 'api/config/apiClient'
import Typography from 'components/atoms/Typography'
import CustomModal from 'components/molecules/CustomModal'
import './EquipamentoMedicoPopup.scss'

// CustomPage renderiza tambem o site publico, entao o pop-up so consulta o
// status dentro da area logada. Mesmo criterio da implementacao anterior.
const LOGGED_AREA_PATHS = ['/app', '/home-cooperado']

// O cadastro fica dentro de /app, mas nao pode receber o pop-up: o "Sim" traz o
// cooperado para ca e a resposta so e gravada ao concluir, entao ele reabriria sobre o formulario.
const CADASTRO_PATH = '/app/equipamento-medico'

// Reaparece a cada acesso enquanto a resposta do cooperado for "nao_respondeu".
function EquipamentoMedicoPopup({ user }) {
  const { store } = useContext(ReactReduxContext)
  const history = useHistory()
  const { pathname } = useLocation()
  const session = useSelector((state) => state?.auth?.user)

  const [open, setOpen] = useState(false)
  const [step, setStep] = useState('question')
  const [confirmNotUse, setConfirmNotUse] = useState(false)
  const [saving, setSaving] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  // Unica origem do CRM: vem do Benner via getUser, o Drupal nao o conhece.
  const crm = user?.crm || session?.crm || ''

  // menu traz so o perfil de maior precedencia (um cooperado auditor vem como
  // "auditor"), entao a role e a fonte confiavel.
  const roles = user?.roles || session?.roles || []
  const isCooperado = roles.includes('cooperado') || user?.menu === 'cooperado'
  const caminho = (pathname || '').replace(/\/+$/, '')
  const isAllowedPath = LOGGED_AREA_PATHS.some((p) => caminho.startsWith(p)) && caminho !== CADASTRO_PATH

  useEffect(() => {
    if (!isCooperado || !isAllowedPath || !store) return

    apiClient
      .request('cache-disable/equipment_usage_status', { crm: String(crm), store })
      .then((res) => {
        const status = res?.applications?.medicalEquipmentUsage?.usageStatus
        if (status?.should_show) setOpen(true)
      })
      .catch(() => {})
  }, [isCooperado, isAllowedPath, crm, store])

  const salvarResposta = async (resposta) => {
    setErrorMsg('')
    setSaving(true)
    try {
      const res = await apiClient.request('cache-disable/equipment_usage_save', {
        crm: String(crm),
        resposta,
        store,
      })
      const saved = res?.applications?.medicalEquipmentUsage?.saveMedicalEquipmentUsage?.submission_id
      return Boolean(saved)
    } catch (error) {
      return false
    } finally {
      setSaving(false)
    }
  }

  const fechar = () => {
    setOpen(false)
    setStep('question')
    setConfirmNotUse(false)
  }

  // "Sim" e so intencao: a resposta "usa" e gravada quando o cadastro conclui, no EquipamentoMedicoForm.
  const handleYes = () => {
    fechar()
    history.push('/app/equipamento-medico')
  }

  const handleNo = () => setStep('justify')

  const handleBack = () => {
    setStep('question')
    setConfirmNotUse(false)
    setErrorMsg('')
  }

  const handleSubmitNo = async () => {
    const ok = await salvarResposta('nao_usa')
    if (!ok) {
      setErrorMsg('Não foi possível registrar sua resposta. Tente novamente mais tarde.')
      return
    }
    fechar()
  }

  return (
    <div className="medical-equipment-popup-modal">
      <CustomModal open={open} closeModal={fechar} size="sm" title="Cadastro de Equipamentos UNIMED">
        {step === 'question' && (
          <div className="text-center">
            <Typography variant="p" color="gray-100">
              Você realiza algum exame complementar pela Unimed?
            </Typography>
            <div className="d-flex justify-content-center mt-3">
              <Button variant="primary" className="mx-1" onClick={handleYes}>
                Sim
              </Button>
              <Button variant="primary" className="mx-1" onClick={handleNo}>
                Não
              </Button>
            </div>
          </div>
        )}

        {step === 'justify' && (
          <div>
            <div className="medical-equipment-popup-modal__declaration mt-2 d-flex align-items-start">
              <input
                type="checkbox"
                id="equipmentConfirmNotUse"
                checked={confirmNotUse}
                onChange={(e) => setConfirmNotUse(e.target.checked)}
                className="medical-equipment-popup-modal__checkbox"
              />
              <label htmlFor="equipmentConfirmNotUse" className="medical-equipment-popup-modal__label">
                <Typography variant="span" color="gray-100">
                  Declaro que não realizo exames complementares aos beneficiários Unimed.
                </Typography>
              </label>
            </div>
            {errorMsg && <p className="text-danger text-center mt-2 mb-0">{errorMsg}</p>}
            <div className="medical-equipment-popup-modal__actions d-flex justify-content-center mt-3">
              <Button variant="secondary" className="mx-1" onClick={handleBack} disabled={saving}>
                Voltar
              </Button>
              <Button variant="primary" className="mx-1" onClick={handleSubmitNo} disabled={!confirmNotUse || saving}>
                {saving ? <Spinner animation="border" size="sm" /> : 'Enviar'}
              </Button>
            </div>
          </div>
        )}
      </CustomModal>
    </div>
  )
}

export default EquipamentoMedicoPopup
